export enum Flipper {
  retailerCollections = 'rt_retailer_collections',
  // TODO: remove me once we launch instacart collections
  instacartCollectionsEnabled = 'rt_retailer_collections_use_instacart_collections',
  retailerCollectionsV2 = 'rt_retailer_collections_ux_v2',
  // Check if retailer collections v2 is enabled for retailers storefront
  retailerCollectionsV2Preview = 'retailer_collections_v2_enabled',
}
